import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-078753dd");

_pushScopeId("data-v-078753dd");

var _hoisted_1 = {
  class: "app-main"
};
var _hoisted_2 = {
  class: "app-main-stage"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createBlock("section", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode(_component_router_view, null, {
    default: _withId(function (_ref) {
      var Component = _ref.Component;
      return [_createVNode(_Transition, {
        name: "fade-transform",
        mode: "out-in"
      }, {
        default: _withId(function () {
          return [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))];
        }),
        _: 2
        /* DYNAMIC */

      }, 1024
      /* DYNAMIC_SLOTS */
      )];
    }),
    _: 1
    /* STABLE */

  })])]);
});